module.exports = __webpack_public_path__ + "static/media/client2.225fef63.avif";